import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';
import { ProgramModel } from '@modules/program/program-model';

export class ProgramService {
    static async update(id, data, manage) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation PROGRAM_UPDATE(
          $id: String!
          $data: ProgramInput!
          $manage: ManageInput!
        ) {
          programUpdate(id: $id, data: $data,   manage: $manage) {
            id
          }
        }
      `,
            variables: {
                id,
                data,
                manage,
            },
        });

        return response.data.programUpdate;
    }

    static async destroyAll(ids, manage) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation PROGRAM_DESTROY($ids: [String!]! $manage: ManageInput!
          ) {
          programDestroy(ids: $ids, manage: $manage)
        }
      `,

            variables: {
                ids,
                manage,
            },
        });

        return response.data.programDestroy;
    }

    static async create(data, manage) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation PROGRAM_CREATE($data: ProgramInput! $manage: ManageInput! ) {
          programCreate(data: $data, manage: $manage) {
            id
          }
        }
      `,

            variables: {
                data,
                manage,
            },
        });

        return response.data.programCreate;
    }

    static async import (values, importHash, manage) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation PROGRAM_IMPORT(
          $data: ProgramInput!
          $importHash: String!
          $manage: ManageInput!
        ) {
          programImport(data: $data, importHash: $importHash, manage: $manage)
        }
      `,
            variables: {
                data: values,
                importHash,
                manage,
            },
        });

        return response.data.programImport;
    }

    static async find(id, manage) {
      if ( !manage.subpropertyId ) return { rows: [], count: 0};
      const response = await graphqlClient.query({
        query: gql `
          query PROGRAM_FIND($id: String! $manage: ManageInput!) {
            programFind(id: $id, manage: $manage) {
              id
              name
              emails
              type
              managers {
                id
                email
                fullName
              }
              status
              access
              createdAt
              updatedAt
            }
          }
        `,

            variables: {
                id,
                manage,
            },
        });

        return response.data.programFind;
    }

    static async list(filter, orderBy, limit, offset, manage) {
      if ( !manage.subpropertyId ) return { rows: [], count: 0};

        const response = await graphqlClient.query({
            query: gql `
        query PROGRAM_LIST(
          $filter: ProgramFilterInput
          $orderBy: ProgramOrderByEnum
          $limit: Int
          $offset: Int
          $manage: ManageInput!
        ) {
          programList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            manage: $manage
          ) {
            count
            rows {
              id
              name
              status
              access
              emails
              type
              subprograms {
                id
                name
                gender
                startDate{
                  day
                  month
                  year
                }
                endDate {
                  day
                  month
                  year
                }
                category {
                  id
                  name
                  minBirthYear
                  maxBirthYear
                  minBirthDate {
                    year
                    month
                    day
                  }
                  maxBirthDate {
                    year
                    month
                    day
                  }
                }
                status
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

            variables: {
                filter,
                orderBy,
                limit,
                offset,
                manage,
            },
        });

        return response.data.programList;
    }

    static async listAutocomplete(query, limit, manage) {

        const response = await graphqlClient.query({
            query: gql `
        query PROGRAM_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $manage: ManageInput!
        ) {
          programAutocomplete(query: $query, limit: $limit, manage: $manage) {
            id
            label
          }
        }
      `,

            variables: {
                query,
                limit,
                manage,
            },
        });

        
        return response.data.programAutocomplete.map(({ id, label}) => {
          const labelSinEspacios = label.replace(/\s/g,''); 
          const labelSplit = labelSinEspacios.split('·'); 
          if (labelSplit.length > 1) {
            var name = labelSplit[0];
            var type = labelSplit[1];
            var typeName = ProgramModel.presenter({ type }, 'type');
            return { id, label: name + " · " + typeName}
          }
          
          return label;
        });
    }
}